import { createClient } from '@supabase/supabase-js'

// Create a function that accepts Supabase configuration
export function createSupabaseClient(supabaseUrl: string, supabaseAnonKey: string) {
  return createClient(supabaseUrl, supabaseAnonKey)
}

// For backward compatibility, export a default instance
// This should be used only in Vite apps where import.meta.env is available
export const supabase = createSupabaseClient(
  import.meta.env?.VITE_SUPABASE_URL || '',
  import.meta.env?.VITE_SUPABASE_ANON_KEY || ''
)

export type SupabaseClient = ReturnType<typeof createSupabaseClient> 